import { FC } from 'react';
import { Bar } from '../types';
import { useElementSize } from '../../util';
import { CHART_MIN_NUMBER_OF_LABELS } from '../constants';
import { GetChartSeriesOptionArgs, GetChartXAxisOptionArgs, getChartMetadata, getChartOptions } from '../util';
import { ClientECharts } from './ClientECharts';

export interface ChartProps
  extends Pick<GetChartSeriesOptionArgs, 'barWidth' | 'barMinHeight'>,
    Pick<GetChartXAxisOptionArgs, 'rangeFilter'>,
    Partial<Pick<GetChartXAxisOptionArgs, 'numberOfLabels'>> {
  className?: string;
  data: Bar[];
}

export const MobileChart: FC<ChartProps> = ({
  data,
  barWidth,
  className,
  rangeFilter,
  barMinHeight,

  numberOfLabels = CHART_MIN_NUMBER_OF_LABELS,
}) => {
  const [boxRef, { width, height }] = useElementSize();

  const positiveMetadata = getChartMetadata(data.map((d) => (d.value >= 0 ? d : null)));
  const negativeMetadata = getChartMetadata(data.map((d) => (d.value < 0 ? d : null)));

  // One chart, one series: positive bars grow up and negative bars grow down
  // from a single shared zero baseline (per-bar colors come from the data).
  // This previously used two overlaid charts, which made negatives render
  // upward and hid the tooltip for whichever series sat underneath (ELE-473).
  const options = getChartOptions({
    xAxisArgs: { data, rangeFilter, numberOfLabels },
    yAxisArgs: {
      maxYValue: Math.max(0, positiveMetadata.maxYValue, negativeMetadata.maxYValue),
      minYValue: Math.min(0, positiveMetadata.minYValue, negativeMetadata.minYValue),
      hasNegativeValues: negativeMetadata.hasValues,
      hasPositiveValues: positiveMetadata.hasValues,
    },
    seriesArgs: { data, barWidth, barMinHeight, containerWidth: width },
    gridArgs: {},
  });

  return (
    <div className={'w-full h-full'} ref={boxRef}>
      {data.length > 0 && <ClientECharts className={className} option={options} style={{ width, height }} />}
    </div>
  );
};
